/**
 * Contains string enums for WebViewer feature flags
 * @name UI.FeatureFlags
 * @property {string} CUSTOMIZABLE_UI Feature flag for the new customizable UI
 */
const FEATURE_FLAGS = {
  CUSTOMIZABLE_UI: 'customizableUI',
};

export default FEATURE_FLAGS;